import React from 'react';

const RoadSVG = () => {
  return (
    <svg
      width="100%"
      viewBox="0 0 1200 200"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute bottom-0 left-0"
    >
      {/* The main black road path */}
      <path
        d="M 0,150 C 200,150 250,50 500,80 S 700,150 950,120 S 1200,120 1200,120"
        stroke="black"
        strokeWidth="60"
        fill="none"
        strokeLinecap="round"
      />
      {/* The white dashes on the road */}
      <path
        d="M 0,150 C 200,150 250,50 500,80 S 700,150 950,120 S 1200,120 1200,120"
        stroke="white"
        strokeWidth="5"
        fill="none"
        strokeDasharray="40 30"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default RoadSVG;